/* src/app/shared-components/mb-collapse/mb-collapse.component.scss */
:host ::ng-deep {
  display: block;
  width: 100%;
}
:host ::ng-deep > div {
  position: relative;
  padding-left: 5px;
}
:host ::ng-deep > div a {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  min-width: 150px;
  text-decoration: none;
}
:host ::ng-deep > div a p {
  font-weight: 600;
  opacity: 0.9;
  margin: 0 0 10px 0;
}
:host ::ng-deep > div a:hover {
  cursor: pointer;
}
:host ::ng-deep > div a:visited {
  color: unset;
}
:host ::ng-deep > div > i {
  display: none;
  font-size: 1.7rem;
}
:host ::ng-deep > div.preicon a > p {
  padding-left: 2.5rem;
}
:host ::ng-deep > div.preicon > i {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  color: rgba(80, 94, 111, 0.75);
}
/*# sourceMappingURL=mb-collapse.component.css.map */
